import {
  GET_AUTONOMOUS_PROVINCE_LIST_START,
  GET_AUTONOMOUS_PROVINCE_LIST,
  GET_AUTONOMOUS_PROVINCE_LIST_ERROR,
} from '../actions/types';

const initialState = {
  autonomousProvinceList: [],
  autonomousProvince: {},
  loading: false,
  error: undefined,
  totalElements: '',
};

const findAllAutonomousProvince = (state, action) => {
  return {
    ...state,
    loading: false,
    autonomousProvinceList: action.payload,
    error: undefined,
  };
};

const findAllAutonomousProvinceStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const findAllAutonomousProvinceError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_AUTONOMOUS_PROVINCE_LIST:
      return findAllAutonomousProvince(state, action);
    case GET_AUTONOMOUS_PROVINCE_LIST_START:
      return findAllAutonomousProvinceStart(state, action);
    case GET_AUTONOMOUS_PROVINCE_LIST_ERROR:
      return findAllAutonomousProvinceError(state, action);

    default:
      return state;
  }
}
